import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, Gift, Crown, UserPlus } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const KEY = "cp_guest_seen";

export default function GuestModal() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (user) return;
    let seen = false;
    try {
      seen = localStorage.getItem(KEY) === "1";
    } catch {}
    if (seen) return;
    const t = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(t);
  }, [user]);

  const close = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center px-5"
          onClick={close} data-testid="guest-modal">
          <motion.div initial={{ opacity: 0, y: 30, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="relative max-w-md w-full bg-surface border border-gold/30 p-8 lg:p-10"
            onClick={(e) => e.stopPropagation()}>
            <button onClick={close} className="absolute top-4 right-4 text-white/40 hover:text-gold transition-colors" data-testid="guest-modal-close" aria-label="Cerrar">
              <X size={20} strokeWidth={1.5} />
            </button>
            <p className="font-heading text-2xl text-white text-center">CINEGÉTICA <span className="text-gold">RUTA DEL AGUA</span></p>
            <p className="mt-1 text-center text-[9px] uppercase tracking-[0.25em] text-sand">Club de Caza · Guillena</p>
            <h2 className="mt-6 text-2xl lg:text-3xl text-white font-light text-center">
              Estás viendo la web como <span className="text-gold italic">invitado</span>
            </h2>
            <ul className="mt-6 space-y-3 text-sm text-white/65 font-light">
              <li className="flex items-center gap-3"><Gift size={16} className="text-gold shrink-0" /> Regístrate gratis y entra en los sorteos del club</li>
              <li className="flex items-center gap-3"><Crown size={16} className="text-gold shrink-0" /> Hazte socio y desbloquea sorteos exclusivos y ofertas</li>
              <li className="flex items-center gap-3"><UserPlus size={16} className="text-gold shrink-0" /> Solo nombre, email y contraseña — 30 segundos</li>
            </ul>
            <Link to="/login" onClick={close} className="btn-gold-solid w-full mt-8" data-testid="guest-modal-register">
              Crear Cuenta Gratis
            </Link>
            <button onClick={close} className="w-full mt-4 text-white/40 hover:text-white text-xs uppercase tracking-[0.15em] transition-colors" data-testid="guest-modal-continue">
              Continuar como invitado →
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
